import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const Navbar = () => {
    const [isSticky, setIsSticky] = useState(false);
    const location = useLocation();
    const { pathname } = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50); // add class after 50px scroll
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    useEffect(() => {
        const nav = document.getElementById("mainNavbar");
        if (nav && nav.classList.contains("show")) {
            window.bootstrap.Collapse.getInstance(nav)?.hide();
        }

        console.log(pathname);
    }, [location]);

    return (
        <header className={isSticky ? "sticky" : "header"}>
            <nav className="navbar navbar-expand-lg fixed-top">
                <div className="container">
                    {/* <Link to="/" className="navbar-brand"><img src="./images/logo.svg" /></Link> */}
                    <Link to="/" className="navbar-brand"><img src="./images/Sewa.svg" width="100%" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar" aria-expanded="false">
                        <img src="./images/burger-menu.svg" alt="Menu" />
                    </button>
                    <div className="collapse navbar-collapse justify-content-end" id="mainNavbar">
                        <div className="navbar-nav">
                            <Link to="/" className={`nav-link ${pathname === '/' ? 'active' : ''}`}>Home</Link>
                            <Link to="/services" className={`nav-link ${pathname === '/services' ? 'active' : ''}`}>Services</Link>
                            <Link to="/about-us" className={`nav-link ${pathname === '/about-us' ? 'active' : ''}`}>About Us</Link>
                            <Link to="/contact-us" className={`nav-link ${pathname === '/contact-us' ? 'active' : ''}`}>Contact Us</Link>
                            <a href="https://calendly.com/preet-sewainsurance/30min" className="nav-link book_appntmnt" target="_blank">book your appointment</a>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )
}